import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import { BRIEF_DEBUG_DATA_VISIBLE } from 'src/lib/featureFlags';
import apolloClient from 'src/store/client';
import { FRAGMENT_CIP_TEXT_ANNOTATIONS } from './schema';

const MUTATION = gql`
  mutation ExtractPerformanceCenterCopyAnnotations(
    $generationTool: GenerationToolEnum!
    $text: String!
    $productName: String
    $workspaceId: ID!
    $maxWordsPerKeyword: Int!
  ) {
    extractPerformanceCenterCopyAnnotationsPerResource(
      generationTool: $generationTool
      text: $text
      productName: $productName
      workspaceId: $workspaceId
      maxWordsPerKeyword: $maxWordsPerKeyword
    ) {
      ...CipTextAnnotations
    }
  }
  ${FRAGMENT_CIP_TEXT_ANNOTATIONS}
`;

const prepareContext = (params) => {
  if (!BRIEF_DEBUG_DATA_VISIBLE) {
    return null;
  }

  const title = `"ExtractPerformanceCenterCopyAnnotations" request [${JSON.stringify(params)}]`;
  return { traceAuthorComplete: true, traceAuthorCompleteTitle: title };
};

export const extractPerformanceCenterCopyAnnotations = async (
  { generationTool, text, productName, workspaceId, maxWordsPerKeyword },
  options = null
) => {
  const variables = { generationTool, text, productName, workspaceId, maxWordsPerKeyword };
  const mutateOptions = {
    mutation: MUTATION,
    variables,
    context: prepareContext(variables),
  };

  if (options?.abortSignal) {
    mutateOptions.context = {
      ...mutateOptions.context,
      fetchOptions: {
        signal: options.abortSignal,
      },
    };
  }

  const result = await apolloClient.mutate(mutateOptions);
  return getSingleProp(result.data) || [];
};
